export const types = {
    INTRO: "INTRO",
    SLIDER: "SLIDER",
    OPEN: "OPEN",
    COMPETITION: "COMPETITION",
};
